import EsamiStrumentaliList from "./pages/EsamiStrumentaliList.vue";
import EsamiStrumentaliView from "./pages/EsamiStrumentaliView.vue";
import EsamiStrumentaliEdit from "./pages/EsamiStrumentaliEdit.vue";

export default {
    EsamiStrumentaliList,
    EsamiStrumentaliView,
    EsamiStrumentaliEdit,
};
